import { render, staticRenderFns } from "./charmOnePage.vue?vue&type=template&id=3092770b"
import script from "./charmOnePage.vue?vue&type=script&lang=js"
export * from "./charmOnePage.vue?vue&type=script&lang=js"
import style0 from "./charmOnePage.vue?vue&type=style&index=0&id=3092770b&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3092770b')) {
      api.createRecord('3092770b', component.options)
    } else {
      api.reload('3092770b', component.options)
    }
    module.hot.accept("./charmOnePage.vue?vue&type=template&id=3092770b", function () {
      api.rerender('3092770b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/charmOnePage.vue"
export default component.exports